<script>
import NotificationItem from './notification-item'
import { mapState } from 'vuex'

export default {
  name: 'Notifications',
  components: { NotificationItem },
  computed: {
    ...mapState({
      items: state => state.notifications.notifications,
    }),
  },
}
</script>

<template>
  <div :class="$style.notifyWrapper">
    <notification-item
      v-for="item in items"
      :key="item.id"
      :notify="item" />
  </div>
</template>

<style lang="scss" module>
@import '@design';
.notifyWrapper {
  position: fixed;
  right: 10px;
  bottom: 5px;
  z-index: 999;
  min-width: 25%;
}
</style>
